import { computed } from 'vue'

export const jobSearchRouteContext = Object.freeze({
  mainRouteName: 'job-search',
  detailRouteName: 'search-ticket-info-panel',
  batchRouteName: 'job-search-batches-info-panel',
  parentRouteShortName: 'search',
})

export function getJobSearchRouteContext() {
  return jobSearchRouteContext
}

export function useJobSearchRouteContext() {
  return {
    mainRouteName: computed(() => jobSearchRouteContext.mainRouteName),
    detailRouteName: computed(() => jobSearchRouteContext.detailRouteName),
    batchRouteName: computed(() => jobSearchRouteContext.batchRouteName),
    parentRouteShortName: computed(() => jobSearchRouteContext.parentRouteShortName),
  }
}
